import React from 'react'
import CountUp, { useCountUp } from "react-countup";
export default function HomeCar  ()  {
  useCountUp({
    ref: "counter",
    start: 0,
    end: 1234567,
    delay: 1000,
    duration: 5000,
  });
  return (
    <>
      <div className="home-carcount">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <h2 className="heading center-heading">
                A Mobility as a Service Platform That Empowers Businesses
              </h2>
            </div>

            <div className="col-lg-10">
              <div className="carcount-row">
                <div className="carcount-box">
                  <img
                    src="./assets/home/dot-icon-1.webp"
                    alt="icon"
                    loading="lazy"
                  />
                  <div>
                    <label>
                      <CountUp end={20} enableScrollSpy /> <small>+</small>
                    </label>
                    <p>Countries</p>
                  </div>
                </div>

                <div className="carcount-box">
                  <img
                    src="./assets/home/dot-icon-2.webp"
                    alt="icon"
                    loading="lazy"
                  />
                  <div>
                    <label>
                      <CountUp end={250} enableScrollSpy /> <small>+</small>
                    </label>
                    <p>Clients</p>
                  </div>
                </div>

                <div className="carcount-box">
                  <img
                    src="./assets/home/dot-icon-3.webp"
                    alt="icon"
                    loading="lazy"
                  />
                  <div>
                    <label>
                      <CountUp end={26} enableScrollSpy /> <small>M+</small>
                    </label>
                    <p>Rides</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="carvector">
          <img
            src="./assets/home/car.webp"
            className="wow animate__animated animate__slideInLeft"
            data-wow-delay="0.1s"
            data-wow-duration="1s"
            alt="car"
            loading="lazy"
          />
        </div>
      </div>
    </>
  );
};
